// extracted by mini-css-extract-plugin
module.exports = {"container":"SupportForm_container__1o8zc","title":"SupportForm_title__1v_pH","inputClassName":"SupportForm_inputClassName__21PtU"};